import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=5b2b24a2&"
import script from "./AboutModal.vue?vue&type=script&lang=js&"
export * from "./AboutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2b24a2')) {
      api.createRecord('5b2b24a2', component.options)
    } else {
      api.reload('5b2b24a2', component.options)
    }
    module.hot.accept("./AboutModal.vue?vue&type=template&id=5b2b24a2&", function () {
      api.rerender('5b2b24a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/AboutModal.vue"
export default component.exports